const de = {
  nav: {
    start: "Start",
    about: "Über mich",
    topics: "Themen",
    methods: "Arbeitsweise",
    pricing: "Kosten",
    faq: "FAQ",
    feedback: "Feedback",
    contact: "Kontakt",
  },
  common: {
    whatsappCta: "Per WhatsApp anfragen",
    whatsappCtaLong: "Kostenfreies Vorgespräch per WhatsApp",
    whatsappAria: "Direkt per WhatsApp Kontakt aufnehmen",
    readMore: "Mehr erfahren",
    toTopic: "Zum Thema",
    newBadge: "Neu",
    related: "Passende Themen",
    backToTopics: "Alle Themen",
    backToMethods: "Alle Methoden",
    onlineBadge: "Auch online verfügbar",
    rating: "4,8/5 · 32 Google-Rezensionen",
    skipToContent: "Zum Inhalt springen",
    menu: "Menü",
    close: "Schließen",
    chapter: "Kapitel",
  },
  wa: {
    message:
      "Guten Tag Frau Rafiq-Arli, ich bitte um einen Termin für ein kostenfreies Vorgespräch. Mit freundlichen Grüßen",
  },
  home: {
    overline: "Praxis für Hypnose & Psychotherapie · Hamburg-Alsterdorf",
    heroLines: ["Klarheit.", "Heilung.", "Innere Freiheit."],
    heroSub:
      "Hypnose, Psychotherapie und Beratung – einfühlsam, kultursensibel und lösungsorientiert. Auf Deutsch und Türkisch, in der Praxis und online.",
    ctaPrimary: "Vorgespräch vereinbaren",
    ctaSecondary: "Themen entdecken",
    marquee: [
      "Trauma",
      "Angst & Phobien",
      "Depression",
      "Selbstwert",
      "Gewicht",
      "Rauchfrei",
      "Trauer",
      "Burnout",
      "Prüfungsangst",
      "Kultursensible Therapie",
    ],
    manifesto: {
      overline: "Meine Haltung",
      title: "Drei Schritte auf einem Weg, den wir gemeinsam gehen",
      chapters: [
        {
          title: "Verstehen",
          text: "Jedes Symptom hat eine Geschichte. Im kostenfreien Vorgespräch höre ich zu – ohne Bewertung, in Ihrem Tempo, auf Augenhöhe.",
        },
        {
          title: "Lösen",
          text: "Mit Hypnose, Havening und EFT erreichen wir die Ursachen dort, wo sie liegen: im Unterbewusstsein. Sanft, sicher, wissenschaftlich fundiert.",
        },
        {
          title: "Stärken",
          text: "Sie verlassen jede Sitzung mit neuen inneren Ressourcen – für ein Leben mit mehr Ruhe, Selbstvertrauen und Freiheit.",
        },
      ],
    },
    topics: {
      overline: "Wobei kann ich helfen?",
      title: "Themen & Anwendungen",
      sub: "Von Trauma bis Rauchstopp: Finden Sie schnell Antworten auf das, was Sie bewegt.",
    },
    methods: {
      overline: "Integrativ & individuell",
      title: "Meine Arbeitsweise",
      sub: "Acht bewährte Methoden, ein Ziel: nachhaltige Veränderung. Ich kombiniere, was zu Ihnen passt.",
      cta: "Alle Methoden ansehen",
    },
    about: {
      overline: "Ihre Therapeutin",
      title: "Naciye Rafiq-Arli",
      text: "Heilpraktikerin für Psychotherapie, geboren in Hamburg, Mutter von vier Kindern. Ich begleite Menschen ganzheitlich – empathisch, kultursensibel und mit Herz.",
      facts: [
        "Heilpraktikerin für Psychotherapie",
        "Deutsch · Türkisch",
        "Praxis & Online-Sitzungen",
      ],
      cta: "Mehr über mich",
    },
    testimonials: {
      overline: "Erfahrungen",
      title: "Was Klient:innen sagen",
      items: [
        {
          quote:
            "Schon nach wenigen Sitzungen konnte ich große Schritte zu Besserung spüren und habe viel positives Feedback von meinem Umfeld bekommen.",
        },
        {
          quote:
            "Ich habe schon nach kurzer Zeit große Veränderungen gesehen und kann es jedem empfehlen, der mit Trauma oder Angststörungen zu kämpfen hat.",
        },
      ],
    },
    ctaBand: {
      title: "Der erste Schritt kostet nichts.",
      text: "Telefonisches Vorgespräch (30 Minuten) – kostenfrei und unverbindlich. Schreiben Sie mir einfach per WhatsApp.",
      button: "Jetzt per WhatsApp starten",
    },
    anfahrt: {
      overline: "Anfahrt",
      title: "So finden Sie die Praxis",
      text: "Traute-Lafrenz-Straße 161 in Hamburg-Alsterdorf – gut erreichbar mit Bus und Bahn. Parkplätze finden Sie in der näheren Umgebung. Viele Sitzungen biete ich auch online an.",
      routeCta: "Route in Google Maps planen",
      mapTitle: "Karte: Praxis für Hypnose & Psychotherapie, Traute-Lafrenz-Straße 161, Hamburg-Alsterdorf",
    },
    values: ["Empathisch", "Vertrauensvoll", "Lösungsorientiert", "Individuell"],
    support: {
      overline: "Unterstützung",
      title: "Wobei ich Sie unterstützen kann",
    },
    approach: {
      overline: "Mein therapeutischer Ansatz",
      title: "Moderne Methoden für nachhaltige Veränderung",
      rows: [
        { key: "hypnose", title: "Hypnose", text: "Zugang zum Unterbewusstsein, um positive Veränderungen zu ermöglichen." },
        { key: "eft", title: "EFT (Emotional Freedom Techniques)", text: "Klopftechnik zur Lösung emotionaler Blockaden und Stress." },
        { key: "havening", title: "Havening", text: "Sanfte Berührungstechniken zur Beruhigung des Nervensystems." },
        { key: "gespraech", title: "Gesprächspsychotherapie", text: "Verstehen, reflektieren und neue Perspektiven entwickeln." },
      ],
      cta: "Mehr zur Arbeitsweise",
    },
  },
  topics: {
    pageOverline: "Anwendungen",
    pageTitle: "Themen, mit denen Sie zu mir kommen können",
    pageSub:
      "Klar erklärt, ohne Fachjargon: Was hinter dem Thema steckt und wie wir es gemeinsam angehen.",
    items: {
      trauma: {
        badge: "Neu",
        title: "Trauma verstehen & auflösen",
        teaser:
          "Belastende Erlebnisse können jahrelang nachwirken. Mit sanften, wirksamen Methoden lösen wir, was Sie festhält.",
        sections: [
          {
            h: "Was ist ein Trauma?",
            paras: [
              "Ein Trauma entsteht, wenn ein Erlebnis zu überwältigend war, um es im Moment zu verarbeiten – etwa ein Unfall, Verlust, Gewalt oder Missbrauch. Körper und Seele speichern das Erlebte dann so ab, als wäre die Gefahr noch da.",
              "Nicht jede schwierige Erfahrung wird zum Trauma. Entscheidend ist, wie das Nervensystem das Erlebte bewertet – und ob es sich danach wieder sicher fühlen konnte.",
            ],
          },
          {
            h: "Wie kann sich ein Trauma auswirken?",
            paras: [
              "Mögliche Folgen sind Schlafprobleme, innere Unruhe, Albträume, plötzliche Angst, Konzentrationsstörungen oder körperliche Beschwerden ohne klare Ursache. Viele Betroffene vermeiden Orte, Menschen oder Situationen, die an das Erlebte erinnern.",
              "Oft steht ein Trauma auch hinter anderen Themen: hinter Angststörungen, Depression, emotionalem Essen oder einem schwachen Selbstwertgefühl.",
            ],
          },
          {
            h: "Wie ich Trauma in meiner Praxis behandle",
            paras: [
              "Zentrale Methode ist Havening – ein psychosensorisches Verfahren, das belastende Erinnerungen über sanfte Berührungen beruhigt und ihre emotionale Ladung löst. Ergänzend arbeite ich mit regressiver Hypnose, um unbewusste Ursachen zu finden, mit EFT zur sanften Entlastung und mit klientenzentrierter Gesprächstherapie als tragender Basis.",
              "Wichtig: Sie bestimmen das Tempo. Alles geschieht in einem geschützten Rahmen – und Sie behalten jederzeit die volle Kontrolle.",
            ],
          },
          {
            h: "Gut zu wissen",
            paras: [
              "Hypnotherapie wurde 2006 vom Wissenschaftlichen Beirat Psychotherapie in Deutschland als wissenschaftlich begründete Methode anerkannt. Viele Klient:innen spüren schon nach wenigen Sitzungen deutliche Entlastung.",
            ],
          },
        ],
        related: ["angst", "depression", "selbstwert", "gewicht"],
      },
      angst: {
        title: "Angststörungen bewältigen",
        teaser:
          "Angst soll uns schützen – manchmal gerät sie außer Kontrolle. Mit Hypnose und Verhaltenstherapie finden wir die Ursache und lösen sie.",
        sections: [
          {
            h: "Was ist eine Angststörung?",
            paras: [
              "Angst ist ein natürlicher Schutzmechanismus. Wird sie zu stark, tritt sie ohne echten Anlass auf oder bestimmt sie den Alltag, spricht man von einer Angststörung – etwa Panikattacken, soziale Angst oder Phobien.",
            ],
          },
          {
            h: "Ursachen & Symptome",
            paras: [
              "Häufige Ursachen sind traumatische Kindheitserlebnisse, lang anhaltender Stress oder ungünstige Lernerfahrungen. Die Angst zeigt sich körperlich – Herzrasen, Schwitzen, Zittern, Atemnot – und seelisch, etwa als ständige Sorge oder Vermeidung.",
              "Unbehandelt kann aus einer Angststörung eine Depression werden. Umso wichtiger ist es, früh etwas zu tun.",
            ],
            list: [
              "Einfache Phobien: Angst vor Tieren, Höhe, Spritzen u. a.",
              "Komplexe Phobien: z. B. soziale Phobie, Agoraphobie",
              "Verdeckte Phobien: Angst zeigt sich indirekt, etwa als körperliche Beschwerden",
            ],
          },
          {
            h: "So behandle ich Angst",
            paras: [
              "Mit regressiver, aufdeckender Kurzzeit-Hypnosetherapie finden wir die Wurzel der Angst – oft in Erlebnissen, die längst vergessen schienen. Kombiniert mit kognitiver Verhaltenstherapie verliert die Angst ihren Boden.",
              "In der Regel genügen wenige Sitzungen, bis Sie eine spürbare Veränderung erleben.",
            ],
          },
        ],
        related: ["trauma", "depression", "selbstwert"],
      },
      depression: {
        title: "Depression – Wege zurück ins Leben",
        teaser:
          "Wenn die Freude verloren geht und alles schwer wird: Wir finden die verborgenen Ursachen und aktivieren Ihre Lebenskraft neu.",
        sections: [
          {
            h: "Typische Symptome",
            paras: [
              "Eine Depression zeigt sich durch gedrückte Stimmung, Interessenverlust, Grübelzwang, Niedergeschlagenheit, Antriebslosigkeit, Konzentrationsprobleme und eine tiefe Erschöpfung, die auch Schlaf nicht heilt.",
            ],
          },
          {
            h: "Woher kommt eine Depression?",
            paras: [
              "Die Ursachen liegen oft im Unbewussten: lang anhaltender Stress, Burnout, ungelöste Konflikte oder eine Angststörung können eine Depression auslösen. Häufig weiß man selbst nicht, warum es so weit gekommen ist.",
            ],
          },
          {
            h: "Meine Behandlung",
            paras: [
              "Mit regressiver Hypnose spüren wir die unbewussten Auslöser auf und lösen sie an der Wurzel. Die kognitive Verhaltenstherapie hilft zusätzlich, belastende Denkmuster Schritt für Schritt zu verändern.",
            ],
          },
        ],
        related: ["angst", "trauma", "trauer"],
      },
      selbstwert: {
        title: "Selbstwertgefühl stärken",
        teaser:
          "Schüchternheit, Selbstzweifel, sich nicht trauen: Hypnose setzt ungeahnte Ressourcen frei und stärkt Sie von innen.",
        sections: [
          {
            h: "Wie sich ein schwaches Selbstwertgefühl zeigt",
            paras: [
              "Es äußert sich als Schüchternheit, Unsicherheit, Durchsetzungsschwäche oder das Gefühl, nie gut genug zu sein – im Privatleben genauso wie im Beruf. Es ist eines der häufigsten Begleitthemen in meiner Praxis.",
            ],
          },
          {
            h: "Woher kommt es?",
            paras: [
              "Oft liegen die Wurzeln in der Kindheit: kritische Stimmen, kränkende Erlebnisse oder Traumata prägen das Bild, das wir von uns selbst haben – bis heute.",
            ],
          },
          {
            h: "Wie Hypnose hilft",
            paras: [
              "In der Trance lösen wir alte Blockaden und verankern neue, stärkende Überzeugungen mit Suggestion und Affirmation direkt im Unterbewusstsein. So wächst ein Selbstwert, der trägt – auch in schwierigen Situationen.",
            ],
          },
        ],
        related: ["trauma", "angst", "depression"],
      },
      gewicht: {
        title: "Gewicht reduzieren mit Hypnose",
        teaser:
          "Diäten scheitern im Kopf. Hypnose verändert Essverhalten dort, wo es gesteuert wird – im Unterbewusstsein.",
        sections: [
          {
            h: "Zwei Wege – passend zu Ihnen",
            paras: [
              "Bei leichtem Übergewicht arbeite ich mit Suggestiv-Hypnose: Neue, gesunde Essgewohnheiten werden direkt verankert. Bei stärkerem Übergewicht und emotionalem Essen nutze ich die analytische Hypnose (Hypnoanalyse), um die tieferen Ursachen aufzulösen.",
            ],
          },
          {
            h: "Emotionales Essen verstehen",
            paras: [
              "Essen wird oft zum Ersatz: Es tröstet über Ängste, Trauer, Trauma oder Beziehungskonflikte hinweg. Solange der seelische Hunger bleibt, scheitert fast jede Diät. Genau hier setzt die Hypnoanalyse an.",
            ],
          },
          {
            h: "Wissenschaftlich belegt",
            paras: [
              "Prof. Dirk Revenstorf von der Universität Tübingen hat in einer Studie nachgewiesen, dass Hypnose bei der Gewichtsreduktion nachhaltig wirksam ist – ohne Jojo-Effekt.",
            ],
          },
        ],
        related: ["trauma", "selbstwert"],
      },
      rauchen: {
        title: "Mit dem Rauchen aufhören",
        teaser:
          "Rauchen ist eine unbewusste Konditionierung. In einer einzigen Intensivsitzung lösen wir sie – nachhaltig rauchfrei.",
        sections: [
          {
            h: "Warum Willenskraft allein nicht reicht",
            paras: [
              "Unsere Gewohnheiten liegen im Unbewussten. Deshalb scheitern Pflaster, Apps und gute Vorsätze so oft: Sie erreichen die Ebene nicht, auf der das Rauchen verankert ist.",
            ],
          },
          {
            h: "Rauchfrei in einer Intensivsitzung",
            paras: [
              "In einer einmaligen Sitzung von etwa 2–4 Stunden lösen wir die Konditionierung und verankern Ihr neues Leben als Nichtraucher:in. Die Erfolgsquote dieser Methode ist hoch – viele meiner Klient:innen gehen rauchfrei nach Hause und bleiben es.",
              "Die Investition: 999 € inkl. MwSt. für das komplette Intensivprogramm.",
            ],
          },
        ],
        related: ["gewicht", "selbstwert"],
      },
      trauer: {
        title: "Trauer verarbeiten & Seelsorge",
        teaser:
          "Verlust, Abschied, schwere Entscheidungen: Sie müssen da nicht allein durch. Einfühlsame Begleitung – unter Schweigepflicht.",
        sections: [
          {
            h: "Seelsorgerliche Begleitung",
            paras: [
              "Trauer braucht Raum und Zeit – und manchmal einen Menschen, der aushält, was ist. Ich begleite Sie bei Verlusterfahrungen, Abschieden, schweren Entscheidungen und tiefen Enttäuschungen.",
              "Als Seelsorgerin unterliege ich der Schweigepflicht. Alles, was Sie mir anvertrauen, bleibt geschützt.",
            ],
          },
          {
            h: "Für wen ist das Angebot?",
            paras: [
              "Für alle, die einen lieben Menschen verloren haben, vor einer Lebensentscheidung stehen oder sich in einer existenziellen Krise befinden – unabhängig von Religion oder Weltanschauung.",
            ],
          },
        ],
        related: ["depression", "trauma"],
      },
      paartherapie: {
        title: "Paartherapie & Eheberatung",
        teaser:
          "Wenn Gespräche schwer werden und Nähe verloren geht: gemeinsam wieder ins Gespräch kommen – strukturiert und ohne Parteinahme.",
        sections: [
          {
            h: "Wann Paartherapie hilft",
            paras: [
              "Jede Beziehung kennt Krisen: wiederkehrende Konflikte, Gespräche, die im Kreis gehen, Vertrauensbrüche oder das Gefühl, sich auseinandergelebt zu haben. Auch große Veränderungen – Kinder, Umzug, berufliche Wendungen – stellen Paare vor neue Aufgaben.",
              "In der Paartherapie bekommen diese Themen einen geschützten Raum. Gemeinsam schauen wir, was hinter den Konflikten liegt und was jede Seite braucht, um sich wieder gesehen zu fühlen.",
            ],
          },
          {
            h: "Wie ich mit Paaren arbeite",
            paras: [
              "Ich arbeite klientenzentriert und kultursensibel – beide Perspektiven haben gleichermaßen Platz, ohne Parteinahme. In strukturierten Gesprächen klären wir Muster, Erwartungen und unerfüllte Bedürfnisse.",
              "Wenn persönliche Themen die Beziehung belasten – etwa alte Verletzungen oder Ängste – kann ich ergänzend einzeln mit Hypnose, EFT oder Havening arbeiten. Auch kulturelle Unterschiede in der Beziehung greife ich mit Erfahrung auf.",
            ],
          },
          {
            h: "Rahmen & Kosten",
            paras: [
              "Paarcoaching und Familiencoaching mit Kindern: 60 Minuten, 390 € inkl. MwSt. – auch online möglich. Der erste Schritt ist wie immer das kostenfreie telefonische Vorgespräch (30 Minuten).",
            ],
          },
        ],
        related: ["trauer", "selbstwert", "angst"],
      },
      beispiele: {
        title: "Behandlungsbeispiele im Überblick",
        teaser:
          "Ein Blick auf die ganze Bandbreite meiner Arbeit – von A wie Angst bis Z wie Zielerreichung.",
        sections: [
          {
            h: "Weitere Anwendungsfelder",
            paras: [
              "Neben den Schwerpunktthemen begleite ich Sie in vielen weiteren Bereichen. Sprechen Sie mich einfach an – im kostenfreien Vorgespräch klären wir, welcher Weg für Sie der richtige ist.",
            ],
            list: [
              "Angst- & Panikstörungen",
              "Burnout",
              "Depressionen",
              "Eifersucht",
              "Entspannung",
              "Flugangst",
              "Gewichtsreduktion",
              "Konzentration",
              "Lampenfieber",
              "Phobien",
              "Prokrastination",
              "Prüfungsangst",
              "Raucherentwöhnung",
              "Selbsthypnose",
              "Selbstwertstärkung",
              "Sexualstörungen",
              "Sporthypnose",
              "Trauer",
              "Vortragsangst",
              "Zielerreichung",
            ],
          },
        ],
        related: ["trauma", "angst", "rauchen"],
      },
    },
  },
  methods: {
    pageOverline: "Arbeitsweise",
    pageTitle: "Acht Methoden, ein Ziel: Ihre Veränderung",
    pageSub:
      "Ich arbeite integrativ – das heißt, ich verbinde bewährte Verfahren zu einem Weg, der zu Ihnen passt.",
    items: {
      hypnose: {
        title: "Klinische Hypnose",
        teaser:
          "Der Schwerpunkt meiner Arbeit: ein natürlicher Zustand tiefer Entspannung, in dem Veränderung möglich wird.",
        sections: [
          {
            h: "Was ist Hypnose?",
            paras: [
              "Hypnose ist ein veränderter Bewusstseinszustand zwischen Wachsein und Schlaf. Sie kennen das Gefühl: wenn Sie so in ein Buch vertieft sind, dass Sie alles um sich herum vergessen.",
              "Etwa 90 Prozent der Menschen können in ausreichendem Maße in Trance gelangen. Und wichtig: Sie behalten während der gesamten Sitzung die volle Kontrolle.",
            ],
          },
          {
            h: "Wissenschaftlich anerkannt",
            paras: [
              "Die Hypnotherapie wurde 2006 vom Wissenschaftlichen Beirat Psychotherapie in Deutschland als wissenschaftlich begründete psychotherapeutische Methode anerkannt. In der Trance beruhigen sich Atmung und Herz-Kreislauf-System, der Stresshormonspiegel sinkt.",
              "Ich arbeite mit Techniken nach G. A. Estabrooks, Milton Erickson und Dave Elman.",
            ],
          },
          {
            h: "So läuft eine Behandlung ab",
            paras: [
              "Wir starten mit einem kostenfreien telefonischen Vorgespräch. In der Erstsitzung (ca. 2–3 Stunden) führen wir ein ausführliches Anamnesegespräch. Die eigentliche Trancearbeit beginnt in der Regel ab der Folgesitzung.",
            ],
          },
        ],
      },
      havening: {
        title: "Havening",
        teaser:
          "Sanfte Berührungen, tiefe Wirkung: eines der modernsten Verfahren zur Auflösung von Trauma, Angst und Blockaden.",
        sections: [
          {
            h: "Was ist Havening?",
            paras: [
              "Havening – von englisch „haven“: Hafen, Zufluchtsort – wurde vom amerikanischen Arzt und Neurowissenschaftler Dr. Ronald Ruden entwickelt. Es zählt zu den psychosensorischen Verfahren: Mehrere Sinnesreize werden kombiniert, um die Psyche positiv zu beeinflussen.",
              "Der sogenannte „Havening Touch“ – gleichmäßige, streichende Berührungen an Gesicht, Handflächen und Armen – beruhigt das Nervensystem nachweislich und nachhaltig.",
            ],
          },
          {
            h: "Wie wirkt es?",
            paras: [
              "Während der Behandlung verschiebt sich die Hirnfrequenz in den Bereich der Deltawellen – jene Frequenz, die mit Tiefschlaf, Zellregeneration und Heilungsprozessen verbunden ist. Empfundener Stress sinkt erstaunlich schnell.",
              "Um die Wirkung sichtbar zu machen, schätzen Sie Ihre Belastung zu Beginn und am Ende selbst auf einer Skala von 0 bis 10 ein (SUD-Wert). Rückgänge von 9 auf 5–6 sind keine Seltenheit.",
            ],
          },
          {
            h: "Für wen und wie lange?",
            paras: [
              "Havening ist meine zentrale Methode zur Auflösung von Trauma, Angstzuständen und Blockaden. In der Regel sind nicht mehr als 4–5 Sitzungen nötig. Wurde die Problemwurzel gefunden, hält die Entlastung dauerhaft an.",
            ],
          },
        ],
      },
      gespraechstherapie: {
        title: "Klientenzentrierte Gesprächstherapie",
        teaser:
          "Sie stehen im Mittelpunkt – nicht Ihr Problem. Nach dem personenzentrierten Ansatz von Carl R. Rogers.",
        sections: [
          {
            h: "Die Grundhaltung",
            paras: [
              "Diese Methode basiert auf dem personenzentrierten Ansatz von Carl R. Rogers: positive Wertschätzung, Vorurteilsfreiheit und echte Begegnung auf Augenhöhe.",
              "Der Fokus liegt auf Ihnen als Person – nicht auf dem Problem. In diesem geschützten Raum finden Sie Ihre eigenen Antworten.",
            ],
          },
          {
            h: "Wofür sie trägt",
            paras: [
              "Die Gesprächstherapie ist die tragende Beziehungsbasis meiner gesamten Arbeit – sie begleitet jede andere Methode und schafft das Vertrauen, das Veränderung erst möglich macht.",
            ],
          },
        ],
      },
      kultursensibel: {
        title: "Kultursensible Therapie & Beratung",
        teaser:
          "Ihre Geschichte, Ihre Kultur, Ihre Sprache: Therapie, die Ihren Hintergrund versteht und ernst nimmt.",
        sections: [
          {
            h: "Was bedeutet kultursensibel?",
            paras: [
              "Migration prägt die seelische Gesundheit – durch Heimatverlust, Sprachbarrieren, Diskriminierung oder den Spagat zwischen zwei Kulturen. In der kultursensiblen Therapie fließen diese Erfahrungen aktiv in die Behandlung ein.",
            ],
          },
          {
            h: "Bedarfsorientiert statt Standard",
            paras: [
              "Das Ziel ist eine Behandlung, die wirklich zu Ihnen passt – zu Ihren Werten, Ihrer Familie, Ihrer Lebenswelt. Ich biete Sitzungen auf Deutsch und auf Türkisch an.",
            ],
          },
        ],
      },
      thetahealing: {
        title: "ThetaHealing®",
        teaser:
          "Blockierende Glaubenssätze erkennen und verwandeln – eine energetische Methode für Körper, Geist und Seele.",
        sections: [
          {
            h: "Was ist ThetaHealing?",
            paras: [
              "ThetaHealing ist eine energetische Trainings- und Meditationsmethode. Sie arbeitet mit den tiefen Glaubenssätzen, die uns steuern – oft seit der frühen Kindheit: „Ich bin nicht gut genug“, „Ich darf nicht scheitern“.",
            ],
          },
          {
            h: "Das Ziel",
            paras: [
              "Blockaden und Ängste werden gelöst, indem alte Überzeugungen gefunden und durch stärkende ersetzt werden. So werden die Selbstheilungskräfte von Körper, Geist und Seele aktiviert.",
            ],
          },
        ],
      },
      beratung: {
        title: "Psychologische Beratung",
        teaser:
          "Wenn das Leben sich neu ordnet: Klarheit und Orientierung in Umbruchphasen.",
        sections: [
          {
            h: "Wann Beratung hilft",
            paras: [
              "Lebensumstände verändern sich – und manchmal braucht es eine neue Ordnung. Psychologische Beratung unterstützt bei Unzufriedenheit, Ängsten, Verunsicherung, Traurigkeit und Entscheidungsblockaden.",
            ],
          },
          {
            h: "Typische Anliegen",
            paras: [
              "Unerfüllte Partnerschaft, berufliche Probleme, anhaltender Stress, Rauchen oder Übergewicht: In der Beratung schauen wir gemeinsam, was Sie brauchen – und welcher Weg der richtige ist. Therapie behandelt Themen mit Krankheitswert, Coaching und Beratung stärken Ihre Persönlichkeit und Lebensgestaltung.",
            ],
          },
        ],
      },
      coaching: {
        title: "Intensiv-Coaching",
        teaser:
          "Für alle, die schnell Klarheit brauchen: konzentriertes Coaching für Beziehungen, Beruf und festgefahrene Muster.",
        sections: [
          {
            h: "Wofür das Intensiv-Coaching?",
            paras: [
              "Manche Fragen brauchen keine lange Therapie, sondern konzentrierte Klarheit: Konflikte in familiären oder freundschaftlichen Beziehungen, berufliche Neuorientierung, der Schritt in die Selbstständigkeit.",
            ],
          },
          {
            h: "Der Nutzen",
            paras: [
              "Wir lösen festgefahrene Denk- und Verhaltensmuster und entwickeln konkrete Lösungen für Ihre Situation – fokussiert, praxisnah und auf Ihre Ziele ausgerichtet.",
            ],
          },
        ],
      },
      lebensstil: {
        title: "Individualpsychologische Lebensstilberatung",
        teaser:
          "Nach Alfred Adler: Verstehen, was Sie antreibt – und Verhaltensmuster gezielt verändern.",
        sections: [
          {
            h: "Der Ansatz",
            paras: [
              "Die Individualpsychologie nach Alfred Adler sieht den Menschen als Ganzes: Prägende Erfahrungen formen unseren „Lebensstil“ – die Art, wie wir denken, fühlen und handeln.",
            ],
          },
          {
            h: "Anwendungsgebiete",
            paras: [
              "Persönlichkeitsberatung, Konfliktberatung, Entscheidungen fällen, Klarheit schaffen, Verhaltensmuster verstehen und verändern – und ganz praktisch: Erziehungsberatung für Eltern.",
            ],
          },
        ],
      },
    },
  },
  pricing: {
    pageOverline: "Transparent & fair",
    pageTitle: "Kosten",
    pageSub:
      "Sie wissen von Anfang an, was eine Sitzung kostet. Alle Preise inkl. 19 % MwSt.",
    items: [
      {
        name: "Vorgespräch (telefonisch)",
        duration: "30 Min.",
        price: "Kostenfrei",
        highlight: true,
        note: "Unverbindliches Kennenlernen und Klärung Ihres Anliegens",
      },
      {
        name: "Beratung & Hypnosecoaching",
        duration: "60 Min.",
        price: "340 €",
        note: "Individuelle Einzelsitzung mit passendem Methodenmix",
      },
      {
        name: "Paarcoaching / Familiencoaching mit Kindern",
        duration: "60 Min.",
        price: "390 €",
        note: "Für Paare und Familien mit Kindern",
      },
      {
        name: "Gewichtsreduktion suggestiv mit Hypnose",
        duration: "60 Min.",
        price: "340 €",
        note: "Verankerung gesunder Essgewohnheiten im Unterbewusstsein",
      },
      {
        name: "Rauchfrei mit Hypnose (Intensivsitzung)",
        duration: "120–180 Min.",
        price: "999 €",
        note: "Einmalige Intensivsitzung mit hoher Erfolgsquote",
      },
      {
        name: "Wochenend- & Feiertagszuschlag",
        duration: "pro 60 Min.",
        price: "50 €",
        note: "Zuschlag für Termine am Wochenende oder an Feiertagen",
      },
    ],
    notes: [
      "Alle Preise inkl. 19 % Mehrwertsteuer.",
      "Pakete für Klient:innen mit weiter Anreise: Preis auf Anfrage.",
      "Zahlung bar zu Sitzungsbeginn. Ausschließlich Selbstzahler:innen.",
      "Private Krankenversicherungen übernehmen die Kosten in der Regel.",
    ],
  },
  faq: {
    pageOverline: "Gut zu wissen",
    pageTitle: "Häufige Fragen",
    pageSub: "Die Antworten, die am häufigsten gesucht werden – kurz und verständlich.",
    items: [
      {
        q: "Was ist der Unterschied zwischen Therapie und Coaching?",
        a: "Therapie behandelt Themen mit Krankheitswert – etwa Angststörungen, Depression oder Trauma. Coaching und Beratung dienen der Persönlichkeitsentwicklung und Themen ohne Krankheitswert, zum Beispiel Gewicht, Stressmanagement, Raucherentwöhnung oder Geburtsvorbereitung.",
      },
      {
        q: "Ist Hypnose sicher?",
        a: "Ja. Hypnose ist ein natürlicher Zustand tiefer Entspannung. Sie behalten während der gesamten Sitzung die volle Kontrolle und können die Trance jederzeit beenden. Die Hypnotherapie ist in Deutschland seit 2006 wissenschaftlich anerkannt.",
      },
      {
        q: "Wie fühlt sich eine Trance an?",
        a: "Jeder Mensch erlebt Trance anders. Viele beschreiben es als angenehme, tiefe Entspannung – vergleichbar mit dem Gefühl, ganz in ein Buch oder einen Film vertieft zu sein. Sie hören alles und können jederzeit reagieren.",
      },
      {
        q: "Hält die Wirkung nachhaltig an?",
        a: "Ja, denn die Veränderungen werden im Unterbewusstsein verankert – dort, wo Gewohnheiten und Muster entstehen. Wurde die Ursache gelöst, bleibt die Entlastung in der Regel dauerhaft bestehen.",
      },
      {
        q: "Bei welchen Themen hilft Hypnose?",
        a: "Das Anwendungsgebiet ist groß: Phobien, Stressabbau, Entspannung, Schlafstörungen, Raucherentwöhnung, Gewicht, Leistungssteigerung, Prüfungsangst, Sporthypnose, Trauerbewältigung und Trennungsschmerz, Beziehungsprobleme, Allergien, Selbstbewusstsein, medizinische Hypnose, Kinderhypnose, Traumreisen, Time Line, Seelenreinigung und Rückführungen.",
      },
      {
        q: "Wie viele Sitzungen brauche ich?",
        a: "Das hängt vom Thema ab. Die Raucherentwöhnung gelingt oft in einer einzigen Intensivsitzung. Bei Angst oder Trauma reichen häufig wenige Sitzungen – Havening benötigt meist 4–5 Termine. Im kostenfreien Vorgespräch gebe ich Ihnen eine ehrliche Einschätzung.",
      },
      {
        q: "Gibt es auch Online-Sitzungen?",
        a: "Ja, viele Sitzungen biete ich auch online an – bequem von zu Hause, mit derselben Sorgfalt wie in der Praxis.",
      },
      {
        q: "Übernimmt die Krankenkasse die Kosten?",
        a: "Meine Praxis ist eine Selbstzahlerpraxis. Private Krankenversicherungen übernehmen die Kosten in der Regel – bitte klären Sie das im Vorfeld mit Ihrer Versicherung.",
      },
    ],
  },
  about: {
    pageOverline: "Über mich",
    pageTitle: "Naciye Rafiq-Arli",
    pageSub: "Heilpraktikerin für Psychotherapie – mit Erfahrung, Fachwissen und Herz.",
    intro:
      "Ich bin Naciye Rafiq-Arli, geboren in Hamburg, Mutter von vier Kindern, PTA mit pharmazeutischer Ausbildung und Heilpraktikerin für Psychotherapie. Mein Schwerpunkt liegt auf Hypnose, Gesprächstherapie und seelsorgerlicher Begleitung. Ich begleite Menschen ganzheitlich – empathisch, kultursensibel und lösungsorientiert.",
    facts: [
      { label: "Geboren", value: "1976 in Hamburg" },
      { label: "Qualifikation", value: "Heilpraktikerin für Psychotherapie" },
      { label: "Ausbildung", value: "PTA / pharmazeutischer Bereich, Studium der Hypnose" },
      { label: "Familie", value: "Mutter von vier Kindern" },
      { label: "Engagement", value: "Gründungsmitglied Rahmet e.V. – muslimische Seelsorge Hamburg" },
      { label: "Sprachen", value: "Deutsch · Türkisch" },
    ],
    approach: {
      title: "Mein Therapieansatz",
      text: "Ich arbeite integrativ mit Hypnose, EFT, Havening und psychotherapeutischen Methoden. Die Hypnosetherapie nutzt den natürlichen Trancezustand, um innere Prozesse gezielt zu bearbeiten. EFT und Havening helfen, emotionale Blockaden sanft zu lösen. Ergänzt wird dies durch eine einfühlsame, klientenzentrierte Gesprächsführung für nachhaltige Veränderung und innere Stabilität.",
    },
    engagement: {
      title: "Mein Engagement",
      text: "Als Gründungsmitglied des Rahmet e.V. engagiere ich mich für muslimische Seelsorge in Hamburg – mit Erfahrung, Fachwissen und Herz.",
    },
    press: {
      title: "Presse & Medien",
      sub: "Bekannt aus Zeitung und Radio – ein Auszug bisheriger Medienauftritte.",
      articleLabel: "Zeitungsartikel",
      radioLabel: "Radio-Interview",
      viewCta: "Ansehen",
    },
    gallery: {
      title: "Ein Blick in die Praxis",
      alts: {
        room: "Heller, ruhiger Therapieraum mit Sessel unter Dachschräge",
        hafencity: "Naciye Rafiq-Arli vor der Hamburger HafenCity",
        certificates: "Zertifikatswand der Praxis",
      },
    },
    helpList: {
      title: "Dabei kann ich dir helfen",
      items: [
        "Ängste & Blockaden: Phobien, Zwang, Depressionen, Trauma",
        "Stress & Erschöpfung: Burnout, innere Unruhe, Schlaflosigkeit",
        "Selbstentwicklung: Selbstbewusstsein, Zielfindung, Lebenskrisen",
        "Verhaltensänderung: Rauchstopp, Gewichtsreduktion",
        "Frauenthemen & Familie: Kinderwunsch, Geburt, Beziehung, Erziehung",
      ],
    },
  },
  contact: {
    pageOverline: "Kontakt",
    pageTitle: "Sprechen wir über Ihr Anliegen",
    pageSub:
      "Der einfachste Weg: Schreiben Sie mir per WhatsApp. Ich melde mich zeitnah bei Ihnen zurück.",
    whatsappTitle: "WhatsApp – direkt & unkompliziert",
    whatsappText:
      "Ein Klick öffnet den Chat mit einer vorbereiteten Nachricht – Sie müssen nur noch auf „Senden“ tippen.",
    whatsappPreviewLabel: "Ihre Nachricht an mich:",
    phoneTitle: "Telefon",
    emailTitle: "E-Mail",
    addressTitle: "Praxis",
    addressNote: "Hamburg-Alsterdorf – gut erreichbar mit Bus & Bahn, Parkplätze in der Nähe.",
    onlineTitle: "Online-Sitzungen",
    onlineText:
      "Kein Weg nach Hamburg nötig: Viele Sitzungen biete ich auch online an – mit derselben Sorgfalt und Wirkung.",
    socialTitle: "Folgen Sie mir",
  },
  footer: {
    tagline: "Praxis für Hypnose & Psychotherapie in Hamburg-Alsterdorf.",
    navTitle: "Navigation",
    contactTitle: "Kontakt",
    legalTitle: "Rechtliches",
    imprint: "Impressum",
    privacy: "Datenschutz",
    copyright: "© 2026 Naciye Rafiq-Arli. Alle Rechte vorbehalten.",
  },
  feedback: {
    pageOverline: "Vertrauen durch Erfahrung",
    pageTitle: "Feedback & Bewertungen",
    pageSub:
      "Stimmen von Klient:innen aus verschiedenen Quellen – damit Sie sich ein ehrliches Bild machen können.",
    sourcesTitle: "Bewertungen im Überblick",
    googleCta: "Auf Google ansehen",
    jamedaCta: "Auf Jameda ansehen",
    jamedaCount: "11 Patienten-Feedbacks",
    reportsCta: "Zu den Berichten",
    reportsCount: "6 ausführliche Berichte im Wortlaut",
    shortTitle: "Kundenstimmen",
    reportsTitle: "Erfahrungsberichte im Wortlaut",
    reportsNote: "",
    fromLabel: "Erfahrungsbericht von",
    sourceLabel: "Quelle",
    sourceWebsite: "hypnosecoachinghamburg.com",
  },
  cookie: {
    title: "Cookies & Datenschutz",
    text: "Wir nutzen Cookies und ähnliche Technologien, um unsere Website optimal zu gestalten und die Nutzung zu analysieren. Sie entscheiden, welche Cookies Sie zulassen. Details finden Sie in unserer Datenschutzerklärung.",
    acceptAll: "Alle akzeptieren",
    essentialOnly: "Nur notwendige",
  },
  legal: {
    imprintTitle: "Impressum",
    imprintBlocks: [
      {
        h: "Angaben gemäß § 5 TMG",
        paras: [
          "Naciye Rafiq-Arli, Heilpraktikerin für Psychotherapie\nTraute-Lafrenz-Straße 161\n22297 Hamburg",
        ],
      },
      {
        h: "Kontakt",
        paras: ["Telefon: +49 176 41 800 480\nE-Mail: n.rafiq-arli@web.de"],
      },
      {
        h: "Berufsbezeichnung",
        paras: [
          "Heilpraktikerin für Psychotherapie (verliehen in Deutschland). Zuständige Behörde: Gesundheitsamt Hamburg.",
        ],
      },
    ],
    privacyTitle: "Datenschutzerklärung",
    privacyBlocks: [
      {
        h: "1. Verantwortliche Stelle",
        paras: [
          "Naciye Rafiq-Arli, Traute-Lafrenz-Straße 161, 22297 Hamburg, E-Mail: n.rafiq-arli@web.de",
        ],
      },
      {
        h: "2. Erhebung und Speicherung personenbezogener Daten",
        paras: [
          "Diese Website erhebt und speichert keine personenbezogenen Daten über Formulare. Bei Kontaktaufnahme per E-Mail, Telefon oder WhatsApp werden Ihre Angaben ausschließlich zur Bearbeitung der Anfrage genutzt und nicht an Dritte weitergegeben.",
        ],
      },
      {
        h: "3. WhatsApp",
        paras: [
          "Bei Nutzung des WhatsApp-Links verlassen Sie diese Website. Es gelten die Datenschutzbestimmungen von WhatsApp (Meta Platforms, Inc.).",
        ],
      },
      {
        h: "4. Ihre Rechte",
        paras: [
          "Sie haben jederzeit das Recht auf Auskunft, Berichtigung und Löschung Ihrer gespeicherten Daten. Wenden Sie sich dazu einfach an die oben genannte Adresse.",
        ],
      },
    ],
  },
};

export default de;
